import { ref } from 'vue'
import { setCookie, getCookie } from '@/utils/cookie'
import appConfig from '@/constants'
const appEnv = import.meta.env.VITE_APP_ENV

export function useAppType() {
  const appType = ref()
  const appName = ref()
  // 当前环境的配置对象
  const currentConfigEnvObj = ref()

  // let xydj = window.location.host.indexOf("vue.whjzjx.cn")
  // let dldj = window.location.host.indexOf("dlvue.xingya.com.cn")
  // let dcdj = window.location.host.indexOf("dcvue.xingya.com.cn")
  // let djdj = window.location.host.indexOf("djvue.xingya.com.cn")

  // const envObj = {
  //   "vue.whjzjx.cn": 'xydj',
  //   "dlvue.xingya.com.cn": 'dldj',
  //   "dcvue.xingya.com.cn": 'dcdj',
  //   "djvue.xingya.com.cn": 'djdj',
  //   "xyvipvue.xingya.com.cn": 'xvdj'
  // }

  // const prefix = appEnv === 'test' ? appEnv +'-' : ''

  // console.log('localStorage.app-type', localStorage.getItem('app-type'))
  // appType.value = localStorage.getItem('app-type') || getCookie(`${prefix}apptype`)

  // // console.log(appType.value, 'appType.value')
  // // console.log(!appType.value, '!appType.value')

  // if (!appType.value) {
  //   // console.log('初始化没有app-type值')
  //   if (window.location.hostname === "localhost" || appEnv === 'test') {
  //     appType.value = 'xydj'
  //   } else {
  //     for(let key in envObj) {
  //       if (window.location.host.indexOf(key) > -1) {
  //         appType.value = envObj[key]
  //       }
  //     }
  //   }
  // }
  // 暂时先写死为一个
  appType.value = 'xydj'
  appName.value = appConfig[appEnv][appType.value]['appName']
  currentConfigEnvObj.value = appConfig[appEnv][appType.value]

  function setAppType(type) {
    appType.value = type
    appName.value = appConfig[appEnv][appType.value]['appName']
    currentConfigEnvObj.value = appConfig[appEnv][appType.value]
    localStorage.setItem('app-type', type)
    console.log('setAppType调用', type)
    setCookie(`${prefix}apptype`, type, { expires: 365 })
  }
  function getAppType() {
    return appType.value
  }
  return {
    appType,
    appName,
    currentConfigEnvObj,
    setAppType,
    getAppType
  }
}
